import SmartphoneNavigateEvent from "../model/SmartphoneNavigateEvent"
import SkinFactory from  "../../../core/ui/SkinFactory";
import { isNull } from "/lib/html5-software-library/src/ranj/util/TypeUtil";
import ScreenNavigator from "../../../../../lib/html5-software-library/src/ranj/ui/ScreenNavigator";

export default class SmartphoneNavigateCommand {
    /**
     * @constructor
     * @param {soma.EventDispatcher} dispatcher 
     * @param {ScreenNavigator} smartphoneScreenNavigator 
     */
    constructor(dispatcher, smartphoneScreenNavigator) {
        this.execute = function(event) {
            const navigateCommandEvent = event.params.data;
            if (isNull(navigateCommandEvent.screen) && !isNull(navigateCommandEvent.screenType)) {
                navigateCommandEvent.screen = SkinFactory.getSkin(navigateCommandEvent.screenType);
            }
            const skin = navigateCommandEvent.screen;
            switch (event.type) {
                case SmartphoneNavigateEvent.OPEN_SCREEN_REQUEST:
                    smartphoneScreenNavigator.openScreen(skin, false, navigateCommandEvent.openUnderCurrent || false, navigateCommandEvent.animationType, navigateCommandEvent.animationOptions);
                    break;
                case SmartphoneNavigateEvent.GOTO_SCREEN_REQUEST:
                    smartphoneScreenNavigator.gotoScreen(skin, navigateCommandEvent.animationType, navigateCommandEvent.animationOptions);
                    break;
                case SmartphoneNavigateEvent.CLOSE_SCREEN_REQUEST:
                    smartphoneScreenNavigator.closeScreen(skin, navigateCommandEvent.animationType, navigateCommandEvent.animationOptions);
                    break;
                case SmartphoneNavigateEvent.CLOSE_ALL_SCREENS_REQUEST:
                    smartphoneScreenNavigator.closeAllScreens();
                    break;
                case SmartphoneNavigateEvent.POP_UP_REQUEST:
                    // TODO add popup property 'customOverlayStyle'           
                    smartphoneScreenNavigator.openPopUp(skin, navigateCommandEvent.needsOverlay, navigateCommandEvent.priority, navigateCommandEvent.autoCenter, null, navigateCommandEvent.animationType, navigateCommandEvent.animationOptions);
                    break;
                case SmartphoneNavigateEvent.CLOSE_POP_UP_REQUEST:
                    smartphoneScreenNavigator.closePopUp(skin, navigateCommandEvent.animationType, navigateCommandEvent.animationOptions);
                    break;
                default:
                    console.info("[Smartphone Navigate command] Unknown navigation command", event.type, navigateCommandEvent);
                    break;
            }
            console.info("[Smartphone Navigate command] Navigate command executed ", event.type, navigateCommandEvent);
        };
    };
}


